import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@/environments/environment';

const url = environment.url;
interface FilterResponse<ResponseData = []> {
  data: ResponseData;
}
@Injectable({
  providedIn: 'root',
})
export class FiltersService {
  constructor(private http: HttpClient) {}

  // service
  async getFilters<ResponseData = []>(params) {
    return this.http.post<FilterResponse<ResponseData>>(`${url}/api/aurora/filtros`, params, { withCredentials: true });
  }
}
